import { render, staticRenderFns } from "./page-container.vue?vue&type=template&id=5f01b89a&"
import script from "./page-container.vue?vue&type=script&lang=js&"
export * from "./page-container.vue?vue&type=script&lang=js&"
import style0 from "./page-container.vue?vue&type=style&index=0&id=5f01b89a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports